import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createPaypalConnection } from "../../Actions/paypalConnectAction";

const ConnectPaypal = () => {
  const [connecting, setConnecting] = useState(false);
  const dispatch = useDispatch();
  const paypalApproval = useSelector(state => state.paypalApproval);

  const handleConnect = () => {
    if(connecting) return;
    setConnecting(true);
    dispatch(createPaypalConnection());
  };

  useEffect(() => {
    if(paypalApproval?.getLink() && connecting) {
      window.location.href = paypalApproval?.getLink();
    }
  }, [paypalApproval, connecting])

  return (
    <>
      <div className="text-center">
        No paypal account connected
      </div>
      <span
        type={connecting ? "text" : "button"}
        className="text-btn"
        onClick={handleConnect}
        aria-disabled={connecting}
      >
        {connecting ? "Connecting..." : "Connect"}
      </span>
    </>
  );
};

export default ConnectPaypal;
